import Phrase from '@insided/deprecated-libs/translationsUtils/phrase'
import { Component } from 'preact'
import EventListOverview from './EventListOverview'

interface EventOverviewProps {
  events: { upcomingEvents: [], pastEvents: [] }
}

class EventOverview extends Component<EventOverviewProps> {
  render() {
    const { events } = this.props
    const { upcomingEvents = [], pastEvents = [] } = events
    const hasUpcomingEvents = upcomingEvents && upcomingEvents.length > 0
    const hasPastEvents = pastEvents && pastEvents.length > 0

    return (
      <div>
        {hasUpcomingEvents && (
          <div className='event-list'>
            <h4 className='event-past-header'><Phrase p='events.title.upcoming' m='Forum' /></h4>
            <EventListOverview eventList={upcomingEvents} className='event-upcoming-wrapper' />
          </div>
        )}

        {hasPastEvents && (
          <div className='event-list'>
            <h4 className='event-past-header'><Phrase p='events.title.past' m='Forum' /></h4>
            <EventListOverview eventList={pastEvents} className='event-upcoming-wrapper' />
          </div>
        )}
      </div>
    )
  }
}

export default EventOverview
